import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PreLogService } from '../../services/pre-log.service';
import { IPreLog } from '../../interfaces/pre-log';
import { ConfigurationService } from '../../services/configuration.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SourceId } from '../../interfaces/source-id.enum';
import { IExternalLinks } from '../../interfaces/external-links';
import { ErrorService } from '../../services/error.service';
import { IContactInformation } from '../../interfaces/contact-information';

@Component({
    selector: 'app-pre-log-complete',
    templateUrl: './pre-log-complete.component.html',
    styles: [],
    standalone: false
})
export class PreLogCompleteComponent implements OnInit, AfterViewInit {
  public preLog: IPreLog;
  public errorMessage: string;
  public externalLinks: IExternalLinks;
  public contactInfo: IContactInformation;

  @ViewChild("arresteeReminder") arresteeReminder!: TemplateRef<any>;
  @ViewChild("pleaAgreementReminder") pleaAgreementReminder!: TemplateRef<any>;
  
  constructor(private readonly titleService: Title,
    private readonly modalService: NgbModal,
    private readonly preLogService: PreLogService,
    private readonly configService: ConfigurationService,
    private readonly errorService: ErrorService) { }

  ngOnInit(): void {
    this.titleService.setTitle("Ready to Send Sample");

    this.preLog = this.preLogService.getCurrentPreLog();
    if (!this.preLog) {
      this.errorMessage = "Error loading Pre-Log data from session. Your session may have expired.  Please refresh your browser and try again.  If you get a duplicate Barcode message on the Pre-Log Entry screen, it means that the Pre-Log information was already saved."
      return;
    }

    this.configService.getExternalLinks()
      .subscribe(
        data => this.externalLinks = data,
        error => this.errorMessage = this.errorService.getErrorMessage(error)
    );

    this.configService.getContactInformation()
      .subscribe(
          data => this.contactInfo = data,
          error => this.errorMessage = this.errorService.getErrorMessage(error)
      );
  }

  ngAfterViewInit() {
    if (this.preLog.sourceId === SourceId.Arrestee)
      this.showArresteeReminder();
    // If PleaAgreement, then show Plea Agreement reminder
    else if (this.preLog.sourceId === SourceId.PleaAgreement)
      this.showPleaAgreementReminder();
  }

  private showArresteeReminder() {
    this.modalService.open(this.arresteeReminder, { ariaLabelledBy: 'modal-basic-title' });
  }

  private showPleaAgreementReminder() {
    this.modalService.open(this.pleaAgreementReminder, { ariaLabelledBy: 'modal-basic-title' });
  }
}
